/** Matches dnd-kit `defaultKeyboardCoordinateGetter` step size. */
export const KEYBOARD_MOVE_DISTANCE = 25
export const EXIT_DURATION_SECONDS = 0.5
export const EXIT_OFFSET_X = 300
export const EXIT_OFFSET_Y = 150
export const EXIT_ROTATION_DEGREES = 60

/** Live drag tilt: degrees ≈ deltaX * factor (also seeds the exit ghost). */
export const DRAG_ROTATION_FACTOR = 0.12

/** Lift applied while dragging — preserved on swipe exit. */
export const DRAG_SCALE = 1.03
